import { clientFetch } from "@flights/client-fetch";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const whitelabelThunkCreator = createAsyncThunk.withTypes();
const CONTEXT_PAGE_MAPPING = {
    index: "index",
    search_results: "search_results",
    flight_details: "flight_details",
    checkout_ticket_type: "checkout_ticket_type",
    checkout_fare: "checkout_fare",
    checkout1: "checkout_passenger",
    checkout2: "checkout_ancillaries",
    checkout3: "checkout_payments",
    confirmation: "confirmation",
    pb_order_details: "pb_order_details",
    pb_extras: "pb_extras"
};
export const whitelabelAncillaryService = {
    getWhitelabels: whitelabelThunkCreator("ancillaries/getWhitelabels", async ({ contextName, geniusLevel, pointOfSale, segments, orderStatus, tripType, orderCurrency }) => {
        return clientFetch("/api/ancillaries/getWhitelabels", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Flights-Context-Name": CONTEXT_PAGE_MAPPING[contextName]
            },
            body: JSON.stringify({ geniusLevel, pointOfSale, segments, orderStatus, tripType, orderCurrency })
        });
    }, {
        condition: (arg, { getState }) => {
            const { whitelabelAncillaries } = getState();
            return whitelabelAncillaries.status === "FULFILLED"
                ? false
                : !whitelabelAncillaries.whitelabelAncillariesLoading;
        }
    })
};
